/** Shared ridge geometry for the gate pages (D32) and the auth hero (D36). */
export const RIDGE_TILE = 1440;
export const RIDGE_HEIGHT = 320;

/**
 * A ridge line that repeats every RIDGE_TILE units, drawn twice so a -50% drift loops
 * seamlessly. Smooth cubic segments with flat tangents give soft, rounded Blue Ridge peaks.
 */
export function ridgePath(ys: number[]): string {
  const step = RIDGE_TILE / ys.length;
  let d = `M0,${RIDGE_HEIGHT} L0,${ys[0]}`;
  for (let tile = 0; tile < 2; tile++) {
    ys.forEach((y0, i) => {
      const y1 = ys[(i + 1) % ys.length]!;
      const x0 = tile * RIDGE_TILE + i * step;
      const x1 = x0 + step;
      d += ` C${x0 + step / 2},${y0} ${x1 - step / 2},${y1} ${x1},${y1}`;
    });
  }
  return `${d} L${RIDGE_TILE * 2},${RIDGE_HEIGHT} Z`;
}
